import javaService from "../../utils/request"
function handel(data) {
  var params = new URLSearchParams()
  for (const key in data) {
    params.append(key, data[key])
  }
  return params
}

//注册
 export function userRegister(data){
  return javaService({
    url: '/user/regist',
    method: 'post',
    data: handel(data),
    isLoading: true
  })
 }

 //获取短信验证码
 export function getVerificationCode(data){
  return javaService({
    url: '/common/captcha/mobileRigist',
    method: 'get',
    params: data,
  })
 }

export function getVerificationCodeNumber(data){
  return javaService({
    url: '/common/captcha/mobileNumber',
    method: 'get',
    params: data,
  })
}

 //修改密码
 export function editPassword(data){
  return javaService({
    url: '/user/frontModifyPass',
    method: 'post',
    data: handel(data),
    isLoading: true
  })
 }
